export enum UserMessageTypes {
    GeneralUserMessage = "GeneralUserMessage",
    PackageDelivery = "PackageDelivery"
}